import { useQuery } from '@tanstack/react-query'
import { cabinetApi, type LayerPalette } from '../api'

/** Палитра слоя из каталога сервера.
 *
 *  Ключ запроса тот же, что у «Карт» и блока оверлеев, — ответ берётся из кэша,
 *  лишнего похода на сервер нет.
 *
 *  Заведён ради легенды апвеллинга: она звала палитру ПО ИМЕНИ (`'YlOrRd'`),
 *  то есть знала цвет слоя мимо каталога. На домене партнёра такая легенда
 *  показывала бы нашу гамму под его картой.
 */
export function useLayerPalette(layerId: string): LayerPalette | undefined {
  const { data } = useQuery({
    queryKey: ['cabinet', 'layers'],
    queryFn: () => cabinetApi.layers(),
  })
  return data?.layers.find(l => l.id === layerId)?.palette
}


/** Строка каталога целиком — когда нужны и палитра, и единица, и способ показа.
 *
 *  Заведён для общей шкалы растра (`maps/scaleRow.ts`): собирать её из двух
 *  отдельных хуков значило бы дважды искать один и тот же слой и однажды
 *  разойтись в том, какой именно слой ищется.
 */
export function useLayerSpec(layerId: string | null | undefined) {
  const { data } = useQuery({
    queryKey: ['cabinet', 'layers'],
    queryFn: () => cabinetApi.layers(),
  })
  if (!layerId) return undefined
  return data?.layers.find(l => l.id === layerId)
}


/** Код единицы слоя из того же каталога.
 *
 *  Заведён, чтобы легенда семьи механизмов не держала СВОЮ таблицу единиц:
 *  вторая копия разъехалась бы с сервером молча — ровно так расходились палитры
 *  карты и пороги скорости судна. `undefined` до приезда каталога значит «пока
 *  не знаем», и легенда просто не пишет единицу.
 */
export function useLayerUnit(layerId: string): string | undefined {
  const { data } = useQuery({
    queryKey: ['cabinet', 'layers'],
    queryFn: () => cabinetApi.layers(),
  })
  return data?.layers.find(l => l.id === layerId)?.unit
}
